// extracted by mini-css-extract-plugin
export default {"scroll-button":"ScrollButton_scroll-button__hBZ9Z"};